var _rect, _path, _path2, _g, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftCalenderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-size",
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1812 -710C-1812 -711.105 -1811.1 -712 -1810 -712H349C350.105 -712 351 -711.105 351 -710V971C351 972.105 350.105 973 349 973H-1810C-1811.1 973 -1812 972.105 -1812 971V-710Z",
    fill: "#E7EAEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1767 -64C-1767 -65.1046 -1766.1 -66 -1765 -66H284C285.105 -66 286 -65.1046 286 -64V850C286 851.105 285.105 852 284 852H-1765C-1766.1 852 -1767 851.105 -1767 850V-64Z",
    fill: "#D0D5DD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_8922_204886)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -251,
    y: -21,
    width: 320,
    height: 308.227,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8922_204886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.35071 4.00003L5.35071 7.00003L8.35071 10",
    stroke: "#64748B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35059 13.5C10.9404 13.5 13.8506 10.5899 13.8506 7.00002C13.8506 3.41016 10.9404 0.500015 7.35059 0.500015C3.76074 0.500015 0.850586 3.41016 0.850586 7.00002C0.850586 10.5899 3.76074 13.5 7.35059 13.5Z",
    stroke: "#64748B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -250.5,
    y: -20.5,
    width: 319,
    height: 307.227,
    rx: 7.5,
    stroke: "#E7EAEE"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1810 -711H349V-713H-1810V-711ZM350 -710V971H352V-710H350ZM349 972H-1810V974H349V972ZM-1811 971V-710H-1813V971H-1811ZM-1810 972C-1810.55 972 -1811 971.552 -1811 971H-1813C-1813 972.657 -1811.66 974 -1810 974V972ZM350 971C350 971.552 349.552 972 349 972V974C350.657 974 352 972.657 352 971H350ZM349 -711C349.552 -711 350 -710.552 350 -710H352C352 -711.657 350.657 -713 349 -713V-711ZM-1810 -713C-1811.66 -713 -1813 -711.657 -1813 -710H-1811C-1811 -710.552 -1810.55 -711 -1810 -711V-713Z",
    fill: "black",
    fillOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_8922_204886",
    x: -299,
    y: -49,
    width: 416,
    height: 404.227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_8922_204886"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.454902 0 0 0 0 0.545098 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8922_204886"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.392157 0 0 0 0 0.454902 0 0 0 0 0.545098 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_8922_204886",
    result: "effect2_dropShadow_8922_204886"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_8922_204886",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8922_204886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.350525)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftCalenderIcon);
export default __webpack_public_path__ + "static/media/LeftCalenderIcon.d2a91a4c79ee9637c6615d57a92db12a.svg";
export { ForwardRef as ReactComponent };